export default "__VITE_ASSET__CuoewASX__"